export default __webpack_public_path__ + "media/assets/fonts/roboto-slab-v13-latin-regular-8cc38ce63cddfd724f22b0cae7b153c4.svg";